import {
  buildTtsCssVariables,
  NOTICE_THEME_VARS,
  type NoticeAppearanceColors,
} from "../shared/appearance";
import { GLASS_VARS } from "./constants";

/**
 * The console colours the injected stylesheets paint with: checkbox and switch
 * states, and the talkback highlight. Only colours the admin set are emitted,
 * so every other value falls back to the stylesheet's own default.
 */
export const buildThemeCssVariables = (
  colors: NoticeAppearanceColors,
): Record<string, string> => {
  const accent = colors.toggle_on ?? colors.accept_all_bg;
  const entries: Array<[string, string | undefined]> = [
    [NOTICE_THEME_VARS.accent, accent],
    [NOTICE_THEME_VARS.controlOff, colors.toggle_off],
    [NOTICE_THEME_VARS.knob, colors.toggle_knob],
    [GLASS_VARS.track, colors.toggle_off],
  ];
  return {
    ...Object.fromEntries(
      entries.filter((entry): entry is [string, string] => entry[1] !== undefined),
    ),
    ...buildTtsCssVariables(colors),
  };
};

/**
 * Sets custom properties on an element. `el()`'s style handling assigns
 * camelCase properties, which a `--name` is not, so these go through
 * `setProperty`.
 */
export const applyCssVariables = (
  element: HTMLElement,
  variables: Readonly<Record<string, string>>,
): void => {
  for (const [name, value] of Object.entries(variables)) {
    element.style.setProperty(name, value);
  }
};
